import { ChangeEvent, useState, useEffect } from "react";
import { Button } from "antd";

import {
  MdMap,
  MdLayers,
  MdChevronRight,
  MdOutlineSearch,
  MdSelectAll
} from "react-icons/md";
import useModal from "../../hooks/useModal";
import useModalSelecaoTalhoes from "../../hooks/useModalSelecaoTalhoes";
import { useTableListTalhoes } from "../../hooks/useTableListTalhoes";
import {
  CustomModal,
  Header,
  ModalContainer,
  ButtonStyled,
  AsideTalhoes,
  AsideTalhoesWrap,
  HeaderAsideTalhoes,
  HeaderAsideTalhoesWrap,
  HeaderAsideTalhoesWrapContentIcon,
  HeaderAsideTalhoesWrapContentTitle,
  ButtonChevronRight,
  ContentFieldSearch,
  ContainerCheckboxAll,
  ContainerCheckboxAllLabel,
  ContainerCheckboxAllInput,
  ContainerCheckboxAllText,
  SectionContent
} from "./styles";
import { ListTalhoes } from "./partials/ListTalhoes";
import { MapTalhoes } from "./partials/MapTalhoes";

function SelecaoTalhoesModal() {
  const [isCollapsedMap, setIsCollapsedMap] = useState(true);
  const [checkedAll, setCheckedAll] = useState(true);

  const { isOpenImportTalhoes, importTalhoesObject, setIsOpenImportTalhoes, setIsOpenImport } = useModal();
  const { setListTalhoesLogicos, listTalhoesLogicos: talhoesLogicos, setListTalhaoLogicoImport } = useModalSelecaoTalhoes();
  const [listItem, setListItem] = useState(importTalhoesObject?.talhoes);
  const [originalList, setOriginalList] = useState(importTalhoesObject?.talhoes);

  const listTalhoesLogicos = listItem?.filter((talhao: any) => talhao?.talhaoId);
  const listTalhoesPlanejados = listItem?.filter((talhao: any) => !talhao?.talhaoId);
  const listTalhoesLogicosMap = listTalhoesLogicos?.filter((talhao: any) => talhao?.geometria);
  const { idSelecao, rows, updateRow } = useTableListTalhoes();

    useEffect(() => {
      setOriginalList(importTalhoesObject?.talhoes);
      setListItem(importTalhoesObject?.talhoes);
        const listTalhoesLogicos = importTalhoesObject?.talhoes
        ?.filter((talhao: any) => talhao?.talhaoId)
        ?.map((talhao: any) => talhao?.talhaoId);
    
        setListTalhoesLogicos(listTalhoesLogicos || []);
    }, [importTalhoesObject]);

  function handleClose() {
    setIsOpenImportTalhoes(false);
    setIsOpenImport(true);
  }

  function handleSelectAll(event: ChangeEvent<HTMLInputElement>) {
    const isChecked = event.target.checked;

    if(isChecked) {
      const allIds = listTalhoesLogicos?.map((item: any) => item.talhaoId);

      setListTalhoesLogicos(allIds);
      setCheckedAll(true);
    } else {
      setListTalhoesLogicos([]);
      setCheckedAll(false);
    }
  }

  useEffect(() => {
    setCheckedAll(true);
  }, [importTalhoesObject]);

  function handleSearchList(event: ChangeEvent<HTMLInputElement>) {
    const search = event.target.value
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
    
    if (search.trim() === "") {
      setListItem(originalList);
      return;
    }

    const result = originalList.filter((item: any) =>
      item.codigo
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .includes(search)
    );

    setListItem(result);
  }

  function handleSubmit() {
    if(idSelecao) {
      const newTalhoesLogicos = listTalhoesLogicos?.map((talhao: any) => {
        if(!talhoesLogicos?.includes(talhao?.talhaoId)) {
          return ({
            ...talhao,
            checked: false
          })
        }
        return ({
          ...talhao
        })
      });
      setListTalhaoLogicoImport(newTalhoesLogicos);
      const rowSelected = rows.findIndex(item => item.idExternoPlanoOperacional === idSelecao);
      updateRow(rowSelected, { edited: true, talhoes: [
        ...listTalhoesPlanejados,
        ...newTalhoesLogicos
      ] });
    }
    handleClose();
  }

  return (
    <CustomModal
      title={
        <Header>
          <MdMap size={28} />
          Seleção de Talhões - {importTalhoesObject?.descricao}
        </Header>
      }
      visible={isOpenImportTalhoes}
      width={"80%"}
      onCancel={handleClose}
      maskClosable={false}
      centered
      getContainer={document.body}
      footer={
          <div>
            <Button
              size="large"
              onClick={handleClose}
              style={{ borderRadius: 8 }}
            >Cancelar</Button>
            <ButtonStyled
              size="large"
              type="primary"
              onClick={handleSubmit}
              style={{ borderRadius: 8, display: "flex", alignItems: "center", gap: 8, float: "right" }}
            >  Confirmar Seleção</ButtonStyled>
          </div>
      }
    >

      <ModalContainer>
        <MapTalhoes 
          isCollapsedMap={isCollapsedMap}
          setIsCollapsedMap={setIsCollapsedMap}
          listTalhoesLogicos={listTalhoesLogicos}
          listTalhoesLogicosMap={listTalhoesLogicosMap}
        />
        <AsideTalhoes isCollapsedMap={!isCollapsedMap}>
          <AsideTalhoesWrap>
            <HeaderAsideTalhoes>
              <HeaderAsideTalhoesWrap>
                <HeaderAsideTalhoesWrapContentIcon>
                  <MdLayers size={18} />
                </HeaderAsideTalhoesWrapContentIcon>
                <HeaderAsideTalhoesWrapContentTitle>
                  <h3>Talhões da Fazenda</h3>
                  <p>Selecione os talhões do pacote</p>
                </HeaderAsideTalhoesWrapContentTitle>
              </HeaderAsideTalhoesWrap>
              <ButtonChevronRight onClick={() => setIsCollapsedMap(!isCollapsedMap)}>
                <MdChevronRight size={24} />
              </ButtonChevronRight>
            </HeaderAsideTalhoes>

            <ContentFieldSearch>
              <input type="search" placeholder="Buscar talhões..." onChange={handleSearchList} />
              <MdOutlineSearch />
            </ContentFieldSearch>

            <ContainerCheckboxAll>
              <ContainerCheckboxAllLabel>
                <ContainerCheckboxAllInput>
                  <input type="checkbox" onChange={handleSelectAll} defaultChecked={checkedAll} checked={checkedAll} />
                </ContainerCheckboxAllInput>
                <ContainerCheckboxAllText>
                  <strong>Seleção em massa</strong>
                </ContainerCheckboxAllText>
                <MdSelectAll />
              </ContainerCheckboxAllLabel>
            </ContainerCheckboxAll>
          </AsideTalhoesWrap>
          <SectionContent>
            {listTalhoesLogicos?.length > 0 && <ListTalhoes listItem={listTalhoesLogicos} title="Talhões Lógicos" icon={MdLayers} isCheckbox /> }
            {listTalhoesPlanejados?.length > 0 && <ListTalhoes listItem={listTalhoesPlanejados} title="Talhões Planejados" icon={MdMap} /> }
          </SectionContent>

        </AsideTalhoes>

      </ModalContainer>

    </CustomModal>
  )
}

export default SelecaoTalhoesModal;